import { render, staticRenderFns } from "./DialogShindansyo.vue?vue&type=template&id=130c9408&scoped=true"
import script from "./DialogShindansyo.vue?vue&type=script&lang=js"
export * from "./DialogShindansyo.vue?vue&type=script&lang=js"
import style0 from "./DialogShindansyo.vue?vue&type=style&index=0&id=130c9408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c9408",
  null
  
)

export default component.exports